import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'libero-instrument-filter-checkboxes',
  templateUrl: './instrument-filter-checkboxes.component.html',
  styleUrls: ['./instrument-filter-checkboxes.component.scss'],
  standalone: false
})
export class InstrumentFilterCheckboxesComponent {
  @Input() public formName!: AbstractControl;
  @Input() public translatePrefix?: string;

  public inputUpdated(): void {
    // workaround to trigger forms valueChange
    this.formName.patchValue(this.formName.value);
    this.formName.markAsTouched();
    this.formName.markAsDirty();
  }
}
